import { render, staticRenderFns } from "./Unitdetails.vue?vue&type=template&id=59d85b85&scoped=true"
import script from "./Unitdetails.vue?vue&type=script&lang=js"
export * from "./Unitdetails.vue?vue&type=script&lang=js"
import style0 from "./Unitdetails.vue?vue&type=style&index=0&id=59d85b85&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d85b85",
  null
  
)

export default component.exports